module.exports = __webpack_public_path__ + "static/sheffield-05e39f7a542e23f63cb4d9a97991a07a.jpg";